
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...landingPage]",
      function () {
        return require("private-next-pages/[...landingPage].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...landingPage]"])
      });
    }
  